<template>

    <div class="connection-modal modal" v-if="ready && open" :class=" mainClasses ">
        <div class="bg"
             @mousedown="setMouseDownTarget($event)"
             @mouseup="closeModal($event)"
        >
            <div class="modal" @mouseup.stop="">
                <div class="modal-inner">
                    <div class="inner-bg" role="presentation"></div>
                    <div class="kids-bg" role="presentation">
                        <div class="frame"></div>
                    </div>

                    <button type="button" class="btn btn-close btn-close-modal"
                            @click="closeModal($event)"
                    ><span class="sr-only">Fermer</span></button>
                    <Login v-if=" 'login' === mode"></Login>
                    <Register v-if=" 'register' === mode"></Register>
                    <forgottenPassword v-if=" 'forgottenPassword' === mode"></forgottenPassword>
                    <resend-confirmation v-if=" 'resendConfirmation' === mode"></resend-confirmation>
                    <Explanation v-if=" 'explanation' === mode "></Explanation>

                </div>
            </div>
        </div>
    </div>
</template>


<script>

export default {
    name       : 'Login Module',
    components : [ ForgottenPassword, Login, Register, ResendConfirmation ],
}
</script>


<script setup>
import { computed, onMounted, inject, ref } from 'vue';
import { useStore }                         from 'vuex';

import Login              from './Login.vue';
import Register           from './Register.vue';
import ForgottenPassword  from "./ForgottenPassword.vue";
import ResendConfirmation from "./ResendConfirmation.vue";
import Explanation        from './Explanation.vue';
import {
    addCustomEventListener,
    freezeBodyScroll,
    isPageWallBlocked,
    isUserLoggedIn,
    isUserProf,
    unfreezeBodyScroll,
}                         from '../../Utils';


let store    = useStore();
let copydeck = computed( () => store.state.copydeck );

let injectedCopydeck = inject( "copydeck" );

let ready = computed( () => store.state.ready );
let mode  = computed( () => store.state.mode );
let open  = computed( () => store.state.open );

let mousedownTarget = ref( null );

let mainClasses = computed( () =>
{

    let classes = [];

    classes.push( 'current-mode_' + mode.value );

    if ( store.getters.isRegistered )
    {
        classes.push( 'is-registered' );
    } else
    {
        classes.push( 'not-registered' );
    }


    if ( store.getters.hasBecomeLoggedIn )
    {
        classes.push( 'connected' );
    }


    classes.push( 'current-audience_' + store.getters.audienceMode );

    // console.log( 'classes', classes );

    return classes.join( ' ' );


} );

async function mounted ()
{


    store.commit( "copydeck", injectedCopydeck );


    store.commit( "ready" );

    window.addEventListener( 'openLoginModal', ( event ) =>
    {
        store.commit( "changeAudience", "jeunes" );
        store.commit( "changeMode", "register" );
        openModal();
    } );


    addCustomEventListener( 'a[href^="#login"]', 'click', handleLoginClicks );
    addCustomEventListener( 'a[href^="#register"]', 'click', handleLoginClicks );
    addCustomEventListener( 'a[href^="#explanation"]', 'click', handleLoginClicks );


    window.addEventListener( 'openExplanationJeunes', ( event ) =>
    {
        store.commit( "changeAudience", "jeunes" );
        store.commit( "changeMode", "explanation" );
        openModal();
    } );

    window.addEventListener( 'openExplanationProfs', ( event ) =>
    {
        store.commit( "changeAudience", "profs" );
        store.commit( "changeMode", "explanation" );
        openModal();
    } );

    window.addEventListener( 'openExplanationProfsSeulement', ( event ) =>
    {
        store.commit( "changeMode", "explanation" );
        store.commit( "changeAudience", "profs-seulement" );
        openModal();
    } );

    window.addEventListener( 'openExplanationJeunesActionProfsSeulement', ( event ) =>
    {
        store.commit( "changeMode", "explanation" );
        store.commit( "changeAudience", "jeune-action-profs-seul" );
        openModal();
    } );


    if ( isPageWallBlocked() )
    {

        store.commit( "changeBlockedMode", true );

        setTimeout( () =>
        {
            store.commit( "changeMode", "explanation" );

            // logged-in jeunes
            if ( isUserLoggedIn() && !isUserProf() )
            {
                store.commit( "changeAudience", "jeune-action-profs-seul" );
            } else
            {
                store.commit( "changeAudience", "profs-seulement" );
            }
            openModal();
        }, 2000 )

    }

}

function handleLoginClicks ( event, targetElement )
{

    const isLoginPromptHashProfs                            = targetElement.href?.indexOf( "#login-profs" ) > -1;
    const isLoginPromptHashJeunes                           = targetElement.href?.indexOf( "#login" ) > -1;
    const isRegistrationPromptHashProfs                     = targetElement.href?.indexOf( "#register-profs" ) > -1;
    const isRegistrationPromptHashJeunes                    = targetElement.href?.indexOf( "#register" ) > -1;
    const isExplanationPromptHashJeunesActionProfsSeulement = targetElement.href?.indexOf( "#explanation-jeune-action-profs-seul" ) > -1;
    const isExplanationPromptHashProfsSeulement             = targetElement.href?.indexOf( "#explanation-profs-seulement" ) > -1;
    const isExplanationPromptHashProfs                      = targetElement.href?.indexOf( "#explanation-profs" ) > -1;
    const isExplanationPromptHashJeunes                     = targetElement.href?.indexOf( "#explanation" ) > -1;


    // console.log(
    //     'isLoginPromptHashProfs', isLoginPromptHashProfs,
    //     'isLoginPromptHashJeunes', isLoginPromptHashJeunes,
    //     'isRegistrationPromptHashProfs', isRegistrationPromptHashProfs,
    //     'isRegistrationPromptHashJeunes', isRegistrationPromptHashJeunes,
    //     'isExplanationPromptHashProfsSeulement', isExplanationPromptHashProfsSeulement,
    //     'isExplanationPromptHashProfs', isExplanationPromptHashProfs,
    //     'isExplanationPromptHashJeunes ', isExplanationPromptHashJeunes,
    // );


    if ( isExplanationPromptHashJeunesActionProfsSeulement )
    {
        event.preventDefault();
        store.commit( "changeMode", "explanation" );
        store.commit( "changeAudience", "jeune-action-profs-seul" );
        openModal();
    } else if ( isExplanationPromptHashProfsSeulement )
    {
        // console.log( 'Trying to open a (PROFS-ONLY) explanation modal' );

        event.preventDefault();
        store.commit( "changeMode", "explanation" );
        store.commit( "changeAudience", "profs-seulement" );
        openModal();

    } else if ( isLoginPromptHashProfs )
    {
        // console.log( 'Trying to open a (PROFS) login modal' );

        event.preventDefault();
        store.commit( "changeMode", "login" );
        store.commit( "changeAudience", "profs" );
        openModal();
    } else if ( isLoginPromptHashJeunes )
    {
        // console.log( 'Trying to open a (JEUNES) login modal' );

        event.preventDefault();
        store.commit( "changeMode", "login" );
        store.commit( "changeAudience", "jeunes" );
        openModal();
    } else if ( isRegistrationPromptHashProfs )
    {
        // console.log( 'Trying to open a (PROFS) registration modal' );

        event.preventDefault();
        store.commit( "changeMode", "register" );
        store.commit( "changeAudience", "profs" );
        openModal();
    } else if ( isRegistrationPromptHashJeunes )
    {
        // console.log( 'Trying to open a (JEUNES) registration modal' );

        event.preventDefault();
        store.commit( "changeMode", "register" );
        store.commit( "changeAudience", "jeunes" );
        openModal();
    } else if ( isExplanationPromptHashProfs )
    {
        // console.log( 'Trying to open a (PROFS) explanation modal' );

        event.preventDefault();
        store.commit( "changeMode", "explanation" );
        store.commit( "changeAudience", "profs" );
        openModal();
    } else if ( isExplanationPromptHashJeunes )
    {
        // console.log( 'Trying to open a (JEUNES) explanation modal' );

        event.preventDefault();
        store.commit( "changeMode", "explanation" );
        store.commit( "changeAudience", "jeunes" );
        openModal();
    }


}

onMounted( mounted );


function setMouseDownTarget ( e )
{

    mousedownTarget.value = e.target;
}

function closeModal ( e )
{

    // only when we really started clicking on the BG
    if ( e.target !== mousedownTarget.value )
    {

        return;
    }


    unfreezeBodyScroll();

    // if ( store.getters.isRegistered || store.getters.hasBecomeLoggedIn )
    // {
    //     return;
    // }


    // redirect on close if on a blocked page
    if ( store.getters.isPageBlocked )
    {
        window.location = "/profs";
    }

    store.commit( 'closeModal' );
}

function openModal ()
{

    // can be done through
    // const event = new Event('openLoginModal');
    // window.dispatchEvent(event);


    freezeBodyScroll();
    store.commit( 'openModal' );
}
</script>

<style scoped>

</style>
